module.exports = __webpack_public_path__ + "img/14.f0d2f8d0.svg";